import { createContext, useContext } from "react";
/**
 * Form bağlamı: `true` → CAD özellik ızgarası (README §2.3: 128 px etiket | beyaz mono değer hücresi, birim sağda),
 * `false` → kâğıt görünümü (etiket üstte, kutulu girdi). Aynı NumberField/Select/Toggle iki yerde de kullanılır.
 */
export const CadFormContext = createContext(false);
export const useCadForm = (): boolean => useContext(CadFormContext);
